export default __webpack_public_path__ + "static/pic03-676ef3e7eb4e3ae3fe90243f7af79944.jpg";